import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"
import { ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import { arrayObject, arrayTypeKeyObject } from "helpers/ConvertKey"
import { maskTel } from "helpers/ConvertMaskData"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsUserFromImportUpdate, creditUpdate } from "store/actions"

import Lg from "language"
import ConfigHost from "services/ConfigHost"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import SendIcon from '@material-ui/icons/Send';

// core components 
import Autocomplete from "components/Autocomplete/Select.jsx";
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      statusWaitingUpdate: true,

      dataListImport: [],
      selectDataListImport: null,

      dataListRaw: [],
      dataList: [],
      selectDataList: null
    }
  }
  componentDidMount() {
    this.onDownloadListImport(() => {
    })
  }
  onDownloadListImport(callback) {
    Alert.Loading(true)
    const dataToSend = {
    }
    APIPost(UrlServer.URL_POST_SMS_DATA_IMPORT_LIST, dataToSend, (datas) => {
      var newConvertDatas = arrayObject(datas.datas, [
        {
          oldKey: "_id",
          newKey: "value"
        },
        {
          oldKey: "_id",
          newKey: "label"
        },
        {
          oldKey: "count",
          newKey: "count"
        },
        {
          oldKey: "created_date_iso",
          newKey: "created_date_iso"
        },
        {
          oldKey: "send_sms_date",
          newKey: "send_sms_date"
        },
      ]
      )
      var select_old = null
      newConvertDatas.map((row, index) => {
        newConvertDatas[index].label += " , ตั้งเวลาส่ง " + (newConvertDatas[index].send_sms_date ? ISOToDateYMDAndFullTime(newConvertDatas[index].send_sms_date) : "-") + " , ถูกสร้างเมื่อ " + ISOToDateYMDAndFullTime(newConvertDatas[index].created_date_iso)
        if (this.state.selectDataListImport != null) {
          if (row.value == this.state.selectDataListImport.value) {
            select_old = newConvertDatas[index]
          }
        }
      })
      this.setState({
        dataListImport: newConvertDatas,
        statusWaitingUpdate: false
      }, () => {
        Alert.LoadingClose()
        // if (select_old != null) {
        //   this.setState({
        //     statusWaitingUpdate: true,
        //   }, () => {
        //     this.setState({
        //       selectDataListImport: select_old,
        //       statusWaitingUpdate: false,
        //     }, () => {
        //       if (callback) callback()
        //     })
        //   })
        // } else {
        if (callback) callback()
        // }
      })
    })

  }
  onDownloadListData(callback) {
    Alert.Loading(true)
    const dataToSend = {
      importName: this.state.selectDataListImport.value
    }
    APIPost(UrlServer.URL_POST_SMS_DATA_IMPORT_DATA, dataToSend, (datas) => {
      this.setState({
        dataListRaw: datas.datas,
        dataList: this.renderListData(datas.datas),
      }, () => {
        Alert.LoadingClose()
        if (callback) callback()
      })
    })

  }

  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        mobile_number: CData.mobile_number ? maskTel(CData.mobile_number) : "-",
        message: CData.mobile_number ? CData.message : "-",
        status_mobile_invalid: (CData.status_mobile_invalid ? "ผิด" : "ถูกรูปแบบ"),
        message_length: CData.message_length ? CData.message_length + "" : "-",
        message_lenguage: CData.message_lenguage ? CData.message_lenguage + "" : "-",
        send_sms_count: CData.mobile_number ? CData.send_sms_count + "" : "-",
        credit_per_msg: CData.credit_per_msg ? CData.credit_per_msg + "" : "-",
        // send_sms_date: CData.send_sms_date ? ISOToDateYMDAndFullTime(CData.send_sms_date) : "-",
        first_send_sms_date: CData.first_send_sms_date ? ISOToDateYMDAndFullTime(CData.first_send_sms_date) : "-",
        last_sent_sms_date: CData.last_sent_sms_date ? ISOToDateYMDAndFullTime(CData.last_sent_sms_date) : "-",
        credit_used: CData.credit_used ? thaiBath(CData.credit_used, false) : "-",

        actions: (
          <div
          // className="actions-right"
          >
            <Button
              size="sm"
              round
              color="danger"
              className={this.props.classes.mb4}
              onClick={e => this.handleDeleteData(CData)}
            >
              <DeleteIcon className={this.props.classes.icons} />
              {Lg.ts('ลบ')}
            </Button>{" "}
            {
              CData.status_mobile_invalid != true ?
                <Button
                  size="sm"
                  round
                  color="info"
                  className={this.props.classes.mb4}
                  onClick={e => this.handleSendSMSNow(CData)}
                >
                  <SendIcon className={this.props.classes.icons} />
                  {Lg.ts('ส่งข้อความ')}
                </Button>
                : null
            }
          </div>
        ),
      }
    })
  }
  handleSendSMSNow = (CData, statusDeleteAll = false) => {
    if (statusDeleteAll) {
      Alert.QuestionCallback("คุณต้องการส่ง SMS ทั้งหมดในรายการใช่หรือไม่? ปุ่มนี้จะส่งเฉพาะ SMS ที่ยังไม่มีการส่งมาก่อน", "blue", () => {
        var ar_id = []
        this.state.dataListRaw.map((row) => {
          if (row.status_mobile_invalid != true) ar_id.push(row._id)
        })
        const dataToSend = {
          sms_id: ar_id,
        }
        Alert.Loading(true)
        APIPost(UrlServer.URL_POST_SMS_SEND_SMS_NOW, dataToSend, (datas) => {
          Alert.LoadingClose()
          if (datas && datas.err) {
            WarningCallback((datas && datas.err ? datas.err : ""), () => {
              this.onDownloadListData()
              this.props.creditUpdate()
            })
          } else {
            SuccessCallback(datas.message, null, () => {
              this.onDownloadListData()
              this.props.creditUpdate()
            })
          }
        })
      })
    } else {
      Alert.QuestionCallback("คุณต้องการส่ง SMS เบอร์ " + CData.mobile_number + " ใช่หรือไม่?", "blue", () => {
        const dataToSend = {
          sms_id: [CData._id],
        }
        Alert.Loading(true)
        APIPost(UrlServer.URL_POST_SMS_SEND_SMS_NOW, dataToSend, (datas) => {
          Alert.LoadingClose()
          if (datas && datas.err) {
            WarningCallback((datas && datas.err ? datas.err : ""), () => {
              this.onDownloadListData()
              this.props.creditUpdate()
            })
          } else {
            SuccessCallback(datas.message, null, () => {
              this.onDownloadListData()
              this.props.creditUpdate()
            })
          }

        })
      })
    }

  }
  handleDeleteData = (CData, statusDeleteAll = false) => {
    if (statusDeleteAll) {
      Alert.WarningCallback("คุณต้องการลบทั้งหมดในรายการใช่หรือไม่?", () => {
        var ar_id = []
        this.state.dataListRaw.map((row) => {
          ar_id.push(row._id)
        })
        const dataToSend = {
          sms_id: ar_id,
        }
        APIPost(UrlServer.URL_POST_SMS_UNACTIVE_SMS, dataToSend, (datas) => {
          SuccessCallback(datas.message, null, () => {
            this.onDownloadListImport(() => {
              this.onDownloadListData()
            })
          })
        })
      }, true)
    } else {
      Alert.WarningCallback("คุณต้องการลบ " + CData.mobile_number + " ใช่หรือไม่?", () => {
        const dataToSend = {
          sms_id: [CData._id],
        }
        APIPost(UrlServer.URL_POST_SMS_UNACTIVE_SMS, dataToSend, (datas) => {
          SuccessCallback(datas.message, null, () => {
            this.onDownloadListImport(() => {
              this.onDownloadListData()
            })
          })
        })
      }, true)
    }
  }

  handleChangeAutoCompleteNormally = name => value => {
    this.setState({
      [name]: value,
    }, () => {
      if (name == "selectDataListImport" && value) {
        this.onDownloadListData()
      }
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{Lg.ts('รายการ SMS นำเข้าระบบโดยการ Import')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} >
                    {
                      !this.state.statusWaitingUpdate ?
                        <Autocomplete
                          handleChange={this.handleChangeAutoCompleteNormally}
                          value={this.state.selectDataListImport}
                          dataList={this.state.dataListImport}
                          id="selectDataListImport"
                          label={Lg.ts('เลือกชื่อรอบการ Import')}
                        // multi
                        />
                        : null
                    }

                    <br />
                  </GridItem>
                </GridContainer>
                {
                  this.state.selectDataListImport ?
                    <div className="W100 ">
                      <span >{Lg.ts('จำนวน')} {thaiBath(this.state.dataList.length, false)} {Lg.ts('รายการ')}</span>
                      <div className="txt-r">
                        <Button
                          size="sm"
                          round
                          color="danger"
                          className={this.props.classes.mb4}
                          onClick={e => this.handleDeleteData({}, true)}
                        >
                          <DeleteIcon className={this.props.classes.icons} />
                          {Lg.ts('ลบรายชื่อที่นำเข้าทั้งหมดในรอบนี้')}
                        </Button>{" "}
                        <Button
                          size="sm"
                          round
                          color="info"
                          className={this.props.classes.mb4}
                          onClick={e => this.handleSendSMSNow({}, true)}
                        >
                          <SendIcon className={this.props.classes.icons} />
                          {Lg.ts('ส่งข้อความทั้งหมดในรอบนี้')}
                        </Button>
                      </div>
                    </div>
                    :
                    <span >{Lg.ts('จำนวน')} {thaiBath(this.state.dataList.length, false)} {Lg.ts('รายการ')}</span>
                }
                <br />
                {/* <i className="txt-c-b1">Password Gen เป็นรหัสที่ตั้งให้จากระบบเมื่อ Import เข้า แต่ถ้าเปลี่ยนรหัสแล้วจะไม่สามารถใช้รหัสนี้เข้าระบบได้ ต้องแจ้ง Administrators เปลี่ยนรหัสใหม่</i> */}
                <ReactTable
                  className="-striped -highlight table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "#",
                      accessor: "id",
                      width: 50
                    },
                    {
                      Header: Lg.ts("ตั้งค่าต่างๆ"),
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      width: 220
                    },
                    {
                      Header: Lg.ts("เบอร์มือถือ"),
                      accessor: "mobile_number",
                      width: 130,
                      filterMethod: (filter, row) => {
                        return row.mobile_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    }, {
                      Header: Lg.ts('เบอร์ผิด'),
                      accessor: "status_mobile_invalid",
                      filterMethod: (filter, row) => {
                        return row.status_mobile_invalid.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ข้อความ"),
                      accessor: "message",
                      width: 330,
                      filterMethod: (filter, row) => {
                        return row.message.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("จำนวนอักษร"),
                      accessor: "message_length",
                      filterMethod: (filter, row) => {
                        return row.message_length.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ภาษาของข้อความ"),
                      accessor: "message_lenguage",
                      filterMethod: (filter, row) => {
                        return row.message_lenguage.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("เครดิตต่อ msg"),
                      accessor: "credit_per_msg",
                      filterMethod: (filter, row) => {
                        return row.credit_per_msg.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ใช้เครดิต"),
                      accessor: "credit_used",
                      filterMethod: (filter, row) => {
                        return row.credit_used.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("จำนวนส่ง SMS แล้ว"),
                      accessor: "send_sms_count",
                      filterMethod: (filter, row) => {
                        return row.send_sms_count.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ครั้งแรกที่ส่ง"),
                      accessor: "first_send_sms_date",
                      filterMethod: (filter, row) => {
                        return row.first_send_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ครั้งล่าสุดที่ส่ง"),
                      accessor: "last_sent_sms_date",
                      filterMethod: (filter, row) => {
                        return row.last_sent_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    // {
                    //   Header: "ตั้งเวลาส่ง",
                    //   accessor: "send_sms_date",
                    //   sortable: false,
                    //   filterable: false,
                    //   filterMethod: (filter, row) => {
                    //     return row.send_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    //   }
                    // },  

                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div >
    )
  }
}

function mapStateToProps({ listsUserFromImport }) {
  return {
    listsUserFromImport: listsUserFromImport
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsUserFromImportUpdate, creditUpdate }
  )
)(UserFromImportListManagement)
